import {
  useSeparator
} from "./D3IXN5NP.js";
import {
  CompositeContext
} from "./WJ37OVG2.js";
import {
  createComponent,
  createElement,
  createHook
} from "./NQJBHION.js";
import {
  __objRest,
  __spreadProps,
  __spreadValues
} from "./PNRLI7OV.js";

// src/composite/composite-separator.ts
import { useContext } from "react";
import { invariant } from "@ariakit/core/utils/misc";
var useCompositeSeparator = createHook(
  (_a) => {
    var _b = _a, { store } = _b, props = __objRest(_b, ["store"]);
    const context = useContext(CompositeContext);
    store = store || context;
    invariant(
      store,
      process.env.NODE_ENV !== "production" && "CompositeSeparator must be wrapped in a Composite component"
    );
    const orientation = store.useState(
      (state) => state.orientation === "horizontal" ? "vertical" : "horizontal"
    );
    props = useSeparator(__spreadProps(__spreadValues({}, props), { orientation }));
    return props;
  }
);
var CompositeSeparator = createComponent(
  (props) => {
    const htmlProps = useCompositeSeparator(props);
    return createElement("hr", htmlProps);
  }
);
if (process.env.NODE_ENV !== "production") {
  CompositeSeparator.displayName = "CompositeSeparator";
}

export {
  useCompositeSeparator,
  CompositeSeparator
};
